import request from '@/libs/request'

// 猪类别 列表
export function pigTypeListApi (data) {
  return request({
    url: `pigFarm/pigType`,
    method: 'get',
    params: data
  })
}

// 猪类别 详情
export function pigTypeDetailApi (id) {
  return request({
    url: `pigFarm/pigType/` + id,
    method: 'get'
  })
}


// 猪类别 编辑/添加
export function pigTypeSaveApi (data) {
  return request({
    url: `pigFarm/pigType`,
    method: 'post',
    data: data
  })
}

// 猪类别 删除
export function pigTypeDelApi (id) {
  return request({
    url: `pigFarm/pigType/` + id,
    method: 'delete'
  })
}

// 猪类别 所有数据
export function pigTypeAllApi (data = {}) {
  return request({
    url: `pigFarm/pigTypeApi/all`,
    method: 'get',
    params: data
  })
}


